import ProductService from '../../services/product-service'
import notification from '../../services/notification-service'
import i18n from './../../i18n'

// initial state
const state = {
    all: [],
    tags: [],

    activeTags: [],
    search: '',
    page: 0,
    totalProducts: 0,

    loadingTags: false,
    loadingProducts: false,
    errorInProducts: false
  }
  
  // getters
  const getters = {
  }
  
  // actions
  const actions = {
    async retrieveProducts ({ commit }) {
      commit('setLoadingProducts', true)
      commit('setErrorInProducts', false)

      const response = await ProductService.getProducts(state.search, state.activeTags, 60, state.page)
      
      if (response.error) { 
        notification.notify(i18n.t('notifications.oops'), response.readable, "error")
        commit('setErrorInProducts', true)
      } else {
        const products = state.page > 0 ? state.all.concat(response.data.products) : response.data.products
        commit('setProducts', products)
        commit('setCurrentPage', state.page + 1)
        commit('setTotalProducts', response.data.total)
      }
      commit('setLoadingProducts', false)
    },
    
    async retrieveTags({commit}) {
      commit('setLoadingTags', true)
      const response = await ProductService.getTags()
      commit('setLoadingTags', false)
      response.error ? notification.notify(i18n.t('notifications.oops'), response.readable, "error") : commit('setTags', response.data);
    },

    setTagActive({commit}, id) {
      commit('setActiveTag', id)
    },
  }
  
  // mutations
  const mutations = {
    setTags(state, tags) {
      state.tags = tags
    },

    setProducts(state, products) {
      state.all = products
    },

    setActiveTag(state, id) {
      state.activeTags = state.activeTags[0] == id ? [] : [id]
    },

    setSearch(state, search) {
      state.search = search;
    },

    setCurrentPage(state, page) {
      state.page = page;
    },

    setTotalProducts(state, total) {
      state.totalProducts = total;
    },

    setLoadingTags(state, isLoading) {
      state.loadingTags = isLoading
    },

    setLoadingProducts(state, isLoading) {
      state.loadingProducts = isLoading
    },

    setErrorInProducts(state, isError) {
      state.errorInProducts = isError
    },
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }

